<template>
  <path
    d="M6.05001 8.05018C3.32001 10.7802 3.32001 15.2002 6.03001 17.9302C7.50001 14.5302 10.12 11.6902 13.39 10.0002C10.62 12.3402 8.68001 15.6102 8.00001 19.3202C10.6 20.5502 13.8 20.1002 15.95 17.9502C18.94 14.9602 19.78 6.81018 19.96 4.57018C19.98 4.26018 19.73 4.01018 19.43 4.04018C17.19 4.22018 9.04001 5.06018 6.05001 8.05018Z"
  />
</template>
